export default function urlPathfromText(text) {
  // remove non-alphanumeric characters except white space
  // replace white space with - and make lower case.
  // e.g. "1. This is a test" becomes "this-is-a-test"

  text = text.replace(/[^a-zA-Z\d\s]/g, "");
  text = text.replace(/\s+/g, "-").toLowerCase();
  return text;
}
